import { defineStore } from 'pinia';
import { localStg } from '@/utils';
import { getLang } from './helpers';
interface LocaleState {
  /** 语言 */
  locale: I18nType.langType;
}

export const useLocaleStore = defineStore('locale-store', {
  state: (): LocaleState => ({
    locale: getLang()
  }),
  actions: {
    /** 设置语言 */
    setLocale(locale: I18nType.langType) {
      this.locale = locale;
      localStg.set('lang', locale);
    }
  }
});
